import type { Feature } from '@tectonics/prs/feature';
import { getFeatureByName, getSupportedTraits } from '@tectonics/prs/feature';

export const getAvailableMobileMoneyNetworks = (
  features: readonly Feature[],
  announcedEwallets: readonly string[],
): readonly string[] => {
  const acceptedBrands = getFeatureByName(features, 'display_ewallet_accepts_brand');

  if (!acceptedBrands) {
    return [];
  }

  return getSupportedTraits(acceptedBrands).filter(network => announcedEwallets.includes(network));
};
